module.exports = __webpack_public_path__ + "img/stidoc_img.11f14707.jpg";